<template>
  <div class="star-wrapper">
    <div class="star-list" v-mouseleve v-if="!noScore">
      <template v-for="i in 5">
        <span v-if="noScore" :key="i" class="star-icon iconfont icon-xing" @click="starRating(i)" :class="{'star-icon-after': i <= (startScore/2)}" :id="'start' + i"></span>
        <span v-else :key="i" class="star-icon iconfont icon-xing" @click="starRating(i)" :class="{'star-icon-after': i <= (startScore/2)}" :id="'start' + i" v-mouseover></span>
      </template>
    </div>
    <p v-if="!noShowText" class="text-center white">
      {{ startScore }}{{ $translate('point') }}
    </p>
    <div class="font-color" v-else>
      <h4 style="color: #f8cf1c;margin-bottom: 6px;text-align:center;font-size: 16px">
        {{ startScore + '.0' || 0 }}
      </h4>
      <div class="flex flex_center">
        <p class="size12">
          {{ $translate('grentdataScore') }}
        </p>
        <span>{{ userScoreCount || 0 }}{{ $translate('evaluationPeopleNum') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  directives: {
    mouseover: {
      // star的鼠标经过指令
      inserted: (el) => {
        el.addEventListener('mousemove', () => {

          prevNode(el.previousSibling)
          nextNode(el.nextSibling || null)

          el.classList.add('hoverColor')
          el.classList.remove('leaveColor')

          function prevNode(node) {
            if (node) {
              node.classList.add('hoverColor')
              node.classList.remove('leaveColor')
              if (node.previousSibling) {
                prevNode(node.previousSibling)
              }
            }
          }
          function nextNode(node) {
            if (node) {
              node.classList.remove('hoverColor')
              node.classList.add('leaveColor')
              if (node.nextSibling) {
                nextNode(node.nextSibling)
              }
            }
          }
        })
      }
    },
    mouseleve: {
      // star外层盒子的鼠标离开指令
      inserted: (el) => {
        el.addEventListener('mouseleave', () => {
          for (let element of el.childNodes) {
            element.classList.remove('hoverColor', 'leaveColor')
          }
        })
      }
    }
  },
  props: {
    noShowText: {
      type: Boolean,
      default: false,
    },
    noScore: {
      type: Boolean,
      default: false
    },
    reportId: {
      default: ''
    }
  },
  data() {
    return {
      startScore: 0,
      userScoreCount: 0
    }
  },
  computed: {
    starWidth() {
      return (Number(this.startScore) / 10 * 5).toFixed(1)
    }
  },
  mounted() {
    let id = this.$route.params.reportId || this.reportId
    if (id) {
      // 获取评分
      // if (id.indexOf('sheet-') > -1) return
      this.$api.UserReportScore.GetItemById(id).then(res => {
        if (res && res.isSuccess) {
          this.startScore = res.data.score;
          this.userScoreCount = res.data.userScoreCount;
        }
      })
    }
  },
  methods: {
    starRating(i) {
      if (this.noScore) {
        return
      }
      this.startScore = i * 2
      this.$emit('setReportScore', this.startScore)
    }
  }
}
</script>

